export default "__VITE_ASSET__CXZLNt5Z__"